export function initInScope($scope) {
    if(!!window.MSInputMethodContext && !!document.documentMode) { // IE 11
        $scope.find('button[type=submit][form]').on('click', function () {
            $(document.getElementById($(this).attr('form'))).submit();
        });
    }
}